<template>
  <div>
    <p>SW = Schulwertung | LW = Landeswertung | BW = Bundeswertung</p>
    <p>
      Gesamt: {{ count ? count : '' }}
    </p>

    <b-input-group class="mb-2">
      <b-input v-model="filter" placeholder="Suchen..."></b-input>
      <b-input-group-append>
        <b-btn :disabled="!filter" @click="filter=''">Filter löschen</b-btn>
      </b-input-group-append>
    </b-input-group>
    <b-table
        :fields="fields"
        :items="items"
        :filter="filter"
        responsive>

      <template v-slot:cell(points)="row">
        <span v-if="row.item.points">{{ row.value }}</span>
        <span v-else>-</span>
      </template>

      <template v-slot:cell(price)="row">
        <span v-if="row.item.price">{{ row.value }}. Preis {{ row.item.level.code }}</span>
      </template>
    </b-table>
  </div>
</template>
<script>
import EditResultModal from '@/components/competitions/results/EditResultModal'
import DeleteResultModal from '@/components/competitions/results/DeleteResultModal'

export default {
  name: 'PricesTable',
  props: ['competition', 'registration'],
  components: {
    editModal: EditResultModal,
    deleteModal: DeleteResultModal
  },
  data: function () {
    return {
      filter: '',
      reloadResults: null,
      fields: [
        {key: 'age', label: 'Stufe', sortable: true},
        {key: 'name', label: 'Name', sortable: true},
        {key: 'points', label: 'Punkte', sortable: true},
        {key: 'price', label: 'Preis'},
        {key: 'buttons', label: ''}
      ],
      items: []
    }
  },

  computed: {
    count: function () {
      return this.items.length
    }
  },

  mounted: function () {
    this.load()
  },

  methods: {
    load: function () {
      this.axios.get('competitions/' + this.competition.id + '/schools/' + this.registration.schoolId + '/prices')
        .then((rsp) => this.$set(this, 'items', rsp.data))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/prices/PricesTable.vue